<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { onBeforeUnmount, onMounted } from 'vue';
import { TEXT } from '../../../../configs/text';
import { useClassStore, useQuizStore, useSignalRStore, useUserStore } from '../../../../stores';
import { UserRole } from '../../../../types/user';
import { ClassStatus } from '../../../../types/class';
import { audioManager } from '../../../../utils/audioManager';
import { QuizAudioKey } from '../../../../types/quiz';

import QuizBGMVolumeControl from './components/QuizBGMVolumeControl.vue';
import QuizInfomation from './components/QuizInfomation.vue';
import ButtonV2 from '../../../General/ButtonV2.vue';
import QuizSetting from './components/QuizSetting.vue';
import QuizPreview from './QuizPreview.vue';
import quizNotStart from '../../../../assets/audios/quiz_not_start.mp3'
import Scale from '../../../Animation/Scale.vue';

const { t } = useI18n();
const quizStore = useQuizStore();
const userStore = useUserStore();
const classStore = useClassStore();
const signalr = useSignalRStore()

onMounted(() => {
    audioManager.play(quizNotStart, QuizAudioKey.BGM, { loop: true, volume: quizStore.bgmVolumeState.volume, muted: quizStore.bgmVolumeState.muted })
})

onBeforeUnmount(() => {
    audioManager.stop(QuizAudioKey.BGM)
})

</script>
<template>
    <Scale>
        <div class="w-full h-full" v-if="quizStore.previewQuiz">
            <QuizPreview />
        </div>
        <div class="relative w-full h-full flex items-center justify-center" v-else>
            <div
                class="border-2 border-yellow-500 dark:border-fuchsia-500 bg-white dark:bg-slate-800 rounded-3xl overflow-hidden w-[547px]">
                <div class="text-center text-white text-3xl font-bold bg-yellow-400 dark:bg-fuchsia-500 py-2">{{
                    t(TEXT.quiz) }}</div>
                <div class="flex flex-col items-center gap-10 p-5 text-xl">
                    <QuizInfomation />
                    <div class="grid grid-cols-3 gap-3 w-full" v-if="userStore.userRole === UserRole.teacher">
                        <ButtonV2 color="primary" class="w-full" animation @click="quizStore.previewQuiz = true">
                            {{ t(TEXT.preview_quiz_btn) }}
                        </ButtonV2>
                        <QuizSetting></QuizSetting>
                        <ButtonV2 color="success" class="w-full" animation @click="signalr.quizStart()"
                            :disabled="classStore.selectedClassDetails?.state === ClassStatus.not_started">
                            {{ t(TEXT.start_quiz_btn) }}
                        </ButtonV2>
                    </div>
                    <div class="w-full flex flex-col gap-3" v-if="userStore.userRole === UserRole.student">
                        <p class="text-center italic">{{ `${t(TEXT.wait_teacher_start_quiz)}` }}</p>
                        <div
                            class="w-full h-7.5 border-2 border-[#F04923] dark:border-fuchsia-500 p-[1px] rounded-full">
                            <div
                                class="bg-gradient-to-r dark:bg-bg-gradient-to-t from-red-400 dark:from-fuchsia-400 to-amber-400 dark:to-fuchsia-400 h-2.5 rounded-full w-full">
                                <div class="progress-striped animate-progress-bar-stripes h-2.5 rounded-full w-full">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute bottom-5 left-5" v-if="userStore.userRole === UserRole.teacher">
                <QuizBGMVolumeControl class=" text-black dark:text-zinc-700 size-10 bg-white" />
            </div>
        </div>
    </Scale>
</template>